import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react'
import DashboardLayout from '../../layouts/DashboardLayout'
import { Helmet } from 'react-helmet'
import AppPageHeader from '../../components/AppPageHeader'
import { inject, observer } from 'mobx-react'
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  message,
  Row,
  Select,
  Space,
  Tabs,
  Tag,
  Tooltip,
  Upload,
} from 'antd'
import { useHistory } from 'react-router-dom'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  DATE_FORMAT_LIST,
  WORK_STATUS,
} from '../../constants'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import queryString from 'query-string'
import moment from 'moment'
import validator from '../../validator'
import RichEditor from '../../components/RichEditor/RichEditor'
import DraggerUploadButton from '../../components/Common/DraggerUploadButton'
import {
  UploadFileListItem,
  UploadFileListWrapper,
} from './PopupWorkForm/PopupWorkFormStyled'
import {
  BankOutlined,
  DeleteOutlined,
  FileTextOutlined,
  TeamOutlined,
  UserOutlined,
} from '@ant-design/icons'
import { blue, yellowPrimary } from '../../color'
import SelectPeoplePopup from '../../components/SelectPeoplePopup'
import SelectGroupPopup from '../../components/SelectGroupPopup'
import {
  SelectList,
  SelectTitle,
} from '../MissionCreatePage/MissionCreatePageStyled'
import { AvatarHasName } from '../../components/Common/Avatar'

const CreateWorkPageV2 = props => {
  const {
    fileStore,
    workStore,
    loadingAnimationStore,
    selectPeopleStore,
    setIsCreatedWork,
    infoOptionStore,
    aclStore,
  } = props || {}

  const history = useHistory()

  const { workTypeList } = workStore

  const {
    selectUserData,
    selectDepartmentData,
    selectGroupData,
    isVisibleSelectGroupPopup,
    setIsVisibleSelectGroupPopup,
    isVisibleSelectUserDepartmentPopup,
    setIsVisibleSelectUserDepartmentPopup,
    handleOpenSelectUserDepartmentPopup,
    handleCancelSelectUserDepartment,
    handleOpenSelectGroupPopup,
    handleCancelSelectGroup,
    clearSelectedHandlerAndFollower,
  } = selectPeopleStore

  const location = useLocation()
  const queryStringParsed = useMemo(
    () =>
      queryString.parse(location.search, {
        arrayFormat: 'index',
      }),
    [location.search]
  )

  const [form] = Form.useForm()
  const EDITOR_REF = useRef()

  const [editorContent, setEditorContent] = useState(null)
  const [handlerList, setHandlerList] = useState([])
  const [followerList, setFollowerList] = useState([])
  const [fileList, setFileList] = useState([])
  const [fileFromDocumentList, setFileFromDocumentList] = useState([])
  const [disableList, setDisableList] = useState([])

  useEffect(() => {
    ;(async () => {
      const disableInfo = await infoOptionStore.load('WORK_SELECT_DISABLE')
      let disables = disableInfo?.split(',') || []
      const isAllowIgnore = await aclStore.checkAccessControlAction(
        ACL_ACTION_TYPE.select_executive_board__WORK
      )
      if (disables?.length > 0 && !isAllowIgnore) {
        setDisableList(disables)
      } else {
        setDisableList([])
      }
    })()
  }, [])

  useEffect(() => {
    setHandlerList([
      ...selectUserData[ASSIGNEE_TYPE.HANDLER],
      ...selectDepartmentData[ASSIGNEE_TYPE.HANDLER],
      ...selectGroupData[ASSIGNEE_TYPE.HANDLER],
    ])
    setFollowerList([
      ...selectUserData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectDepartmentData[ASSIGNEE_TYPE.FOLLOWER],
      ...selectGroupData[ASSIGNEE_TYPE.FOLLOWER],
    ])
  }, [selectUserData, selectDepartmentData, selectGroupData])

  useEffect(() => {
    // Check if the form is already filled
    const isFormFilled = form.getFieldsValue(true)

    if (!isFormFilled.work_type) {
      const incoming_number = queryStringParsed?.incoming_number || ''
      const title = queryStringParsed?.document_title || ''
      const comments_leader = queryStringParsed?.comments_leader?.length
        ? queryStringParsed?.comments_leader
        : ''
      const leader_name =
        queryStringParsed?.leader_name &&
        queryStringParsed?.comments_leader?.length > 0
          ? `Đ/c ${queryStringParsed?.leader_name}: `
          : ''

      if (queryStringParsed?.document_code) {
        form.setFieldsValue({
          work_type: WORK_STATUS.DOCUMENT,
          title: `Xử lý văn bản ${
            incoming_number ? 'đến ' + incoming_number : 'đi'
          }: ${title}`,
          content: setEditorContent(
            `Nội dung: ${title + '. \n'}${leader_name} ${comments_leader}`
          ),
          start_date: moment(),
        })

        const files = queryStringParsed?.document_list?.map(file => ({
          file_id: file.split('/')[0],
          file_name: file.split('/').slice(1).join(),
        }))
        setFileFromDocumentList(files)
      } else if (queryStringParsed?.mission_code) {
        form.setFieldsValue({
          work_type: WORK_STATUS.DEPLOY,
        })
      } else {
        form.setFieldsValue({
          work_type: WORK_STATUS.OTHER,
        })
      }
    }
  }, [queryStringParsed, form])

  const handleChangeFile = useCallback(info => {
    const filteredFileList = info.fileList.filter(
      (elem, index, fileArray) =>
        fileArray.findIndex(file => file.name === elem.name) === index
    )
    setFileList(filteredFileList)
  }, [])

  const handleRemoveFileFromUploadList = fileUID => {
    const newFileList = fileList.filter(file => file.uid !== fileUID)
    setFileList(newFileList)
  }

  const handleRemoveFileFromDocumentList = file_id => {
    const newFileList = fileFromDocumentList.filter(
      file => file.file_id !== file_id
    )
    setFileFromDocumentList(newFileList)
  }

  const onFinish = async value => {
    if (handlerList.length === 0)
      return message.warning('Bạn chưa chọn người xử lý công việc!')
    const assigneesList = [...followerList, ...handlerList].map(el => ({
      assignee_code: el.id,
      assignee_type: el.assignee_type,
      permission: el.permission,
    }))
    const { title, start_date, due_date, work_type } = value
    const uploadFileList = fileList.map(file => file.originFileObj)
    const batchUploadArr = []
    uploadFileList.forEach(file => {
      const formData = new FormData()
      formData.append('file', file)
      batchUploadArr.push(fileStore.uploadFile(formData))
    })

    try {
      loadingAnimationStore.showSpinner(true)
      const response = await Promise.all(batchUploadArr)
      const dataSubmit = {
        title: title,
        start_date: start_date,
        related_documents:
          queryStringParsed?.document_code && queryStringParsed.document_type
            ? [
                {
                  code: queryStringParsed.document_code,
                  type: queryStringParsed.document_type,
                },
              ]
            : [],
        related_tasks: queryStringParsed?.mission_code && [
          queryStringParsed?.mission_code,
        ],
        due_date: due_date,
        content: EDITOR_REF?.current?.editor?.getData?.(),
        attachments: response
          .map(response => response.data.file_id)
          .concat(fileFromDocumentList.map(file => file.file_id)),
        assignees: assigneesList,
        parent_id: null,
        work_type: work_type,
        document_code: queryStringParsed?.document_code || null,
      }
      await workStore.createWork(dataSubmit)

      workStore.clearQueryParams()
      workStore.clearWorkList()
      await workStore.getWorkList()
      // clearSelectPeopleStore();
      message.success('Tạo mới thành công!')
      clearSelectedHandlerAndFollower()

      handleCancel()
      setIsCreatedWork(true)
    } catch (err) {
      console.log(err)
      // message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      loadingAnimationStore.showSpinner(false)
      workStore.getWorkList()
    }
  }

  const handleCancel = () => {
    selectPeopleStore.clearSelectedHandlerAndFollower()
    form.resetFields()
    history.push('/works')
  }

  return (
    <>
      <DashboardLayout>
        <Helmet>
          <title>Tạo công việc mới</title>
        </Helmet>
        <AppPageHeader title="Tạo công việc mới" />

        <Form onFinish={onFinish} form={form} layout="vertical">
          <div className="custom-create-page-content-wrapper">
            <h3 style={{ marginBottom: 20, fontSize: 18, fontWeight: 600 }}>
              Thông tin chung
            </h3>

            <Form.Item
              style={{ display: 'none' }}
              label={'Loại công việc'}
              name={'work_type'}
              rules={[
                { required: true, message: 'Vui lòng chọn loại công việc' },
              ]}>
              <Select placeholder={'Chọn loại công việc'}>
                {workTypeList
                  ?.filter(type =>
                    !queryStringParsed?.document_code &&
                    !queryStringParsed?.mission_code
                      ? type.id !== 'DOCUMENT' &&
                        type.id !== 'DEPLOY' &&
                        type.id !== 'ELECTRONIC'
                      : type
                  )
                  .map(workType => (
                    <Select.Option
                      key={workType.id}
                      value={workType.id}
                      name={workType.name}>
                      {workType.name}
                    </Select.Option>
                  ))}
              </Select>
            </Form.Item>

            <Form.Item
              label={'Tiêu đề:'}
              name={'title'}
              rules={[
                { required: true, message: 'Vui lòng nhập tiêu đề' },
                {
                  max: 499,
                  message: 'Tiêu đề đã đủ 500 ký tự, không thể nhập thêm!',
                },
                { validator: validator.validateInputString },
              ]}>
              <Input
                maxLength={500}
                placeholder={'Nhập tiêu đề...'}
                className="h-40"
              />
            </Form.Item>

            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Form.Item
                  label={'Ngày bắt đầu:'}
                  rules={[
                    { required: true, message: 'Vui lòng chọn ngày bắt đầu!' },
                  ]}
                  name={'start_date'}>
                  <DatePicker
                    format={DATE_FORMAT_LIST}
                    className="h-40"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  label={'Ngày kết thúc:'}
                  name={'due_date'}
                  rules={[
                    {
                      required: false,
                      message: 'Vui lòng chọn ngày kết thúc!',
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const startDate = getFieldValue('start_date')
                        if (!startDate || !value) {
                          //! Không thực hiện kiểm tra nếu ngày bắt đầu hoặc ngày kết thúc không có giá trị
                          return Promise.resolve()
                        }
                        if (value.isAfter(startDate)) {
                          //! Ngày kết thúc lớn hơn ngày bắt đầu
                          return Promise.resolve()
                        }
                        //! Ngày kết thúc không hợp lệ
                        return Promise.reject(
                          'Ngày kết thúc phải lớn hơn ngày bắt đầu!'
                        )
                      },
                    }),
                  ]}>
                  <DatePicker
                    format={DATE_FORMAT_LIST}
                    className="h-40"
                    style={{ width: '100%' }}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <SelectTitle>
                  <span>
                    <span
                      style={{
                        color: '#ff4d4f',
                        fontFamily: 'SimSun, sans-serif',
                        marginRight: '-4px',
                      }}>
                      *{' '}
                    </span>
                    <span style={{ marginRight: '10px' }}>Người xử lý:</span>
                  </span>
                  <Space>
                    <Tooltip title="Chọn người dùng" color={blue}>
                      <Button
                        className="select-user-icon-btn"
                        icon={<UserOutlined style={{ color: blue }} />}
                        onClick={() =>
                          handleOpenSelectUserDepartmentPopup(
                            ASSIGNEE_TYPE.HANDLER
                          )
                        }
                      />
                    </Tooltip>
                    <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                      <Button
                        className="select-user-icon-btn"
                        icon={<TeamOutlined />}
                        style={{ color: yellowPrimary }}
                        onClick={() =>
                          handleOpenSelectGroupPopup(ASSIGNEE_TYPE.HANDLER)
                        }
                      />
                    </Tooltip>
                  </Space>
                </SelectTitle>
                <SelectList>
                  {handlerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </SelectList>
              </Col>

              <Col span={12}>
                <SelectTitle>
                  <span>
                    <span style={{ marginRight: '10px' }}>Người theo dõi:</span>
                  </span>
                  <Space>
                    <Tooltip title="Chọn người dùng" color={blue}>
                      <Button
                        className="select-user-icon-btn"
                        icon={<UserOutlined style={{ color: blue }} />}
                        onClick={() =>
                          handleOpenSelectUserDepartmentPopup(
                            ASSIGNEE_TYPE.FOLLOWER
                          )
                        }
                      />
                    </Tooltip>
                    <Tooltip title="Chọn nhóm" color={'#ffc069'}>
                      <Button
                        className="select-user-icon-btn"
                        icon={<TeamOutlined />}
                        style={{ color: yellowPrimary }}
                        onClick={() =>
                          handleOpenSelectGroupPopup(ASSIGNEE_TYPE.FOLLOWER)
                        }
                      />
                    </Tooltip>
                  </Space>
                </SelectTitle>
                <SelectList>
                  {followerList.map(el => (
                    <Tag
                      className={'tag-selected'}
                      color={'blue'}
                      key={el.id}
                      closable
                      onClose={() => selectPeopleStore.handleRemoveSelect(el)}>
                      <AvatarHasName
                        imgId={el.image_id}
                        size={22}
                        name={el.full_name}
                        icon={
                          (el.assignee_type === ASSIGNEE_TYPE.DEPARTMENT && (
                            <BankOutlined />
                          )) ||
                          (el.assignee_type === ASSIGNEE_TYPE.GROUP && (
                            <TeamOutlined />
                          ))
                        }
                      />
                    </Tag>
                  ))}
                </SelectList>
              </Col>

              <Col span={24}>
                <Tabs defaultActiveKey="1" destroyInactiveTabPane={false}>
                  <Tabs.TabPane tab="Nội dung" key="1" forceRender>
                    <Form.Item label={'Nội dung:'} name={'content'}>
                      <div style={{ background: '#ffffff', borderRadius: 8 }}>
                        <RichEditor
                          EDITOR_REF={EDITOR_REF}
                          placeholder={'Nhập nội dung...'}
                          editorContent={editorContent}
                        />
                      </div>
                    </Form.Item>
                  </Tabs.TabPane>
                  <Tabs.TabPane tab="Tài liệu đính kèm" key="2" forceRender>
                    <Form.Item
                      label={'Tài liệu đính kèm:'}
                      name={'id_file_dinh_kem'}>
                      <Upload.Dragger
                        valuePropName={'fileList'}
                        fileList={fileList}
                        multiple={true}
                        onChange={handleChangeFile}
                        beforeUpload={() => false}
                        showUploadList={false}
                        className="custom-dragger-upload bg-white">
                        <DraggerUploadButton />
                      </Upload.Dragger>
                    </Form.Item>
                    {fileFromDocumentList.length !== 0 && (
                      <UploadFileListWrapper>
                        {fileFromDocumentList.map(file => (
                          <UploadFileListItem key={file.file_id}>
                            <FileTextOutlined style={{ color: blue }} />
                            <span
                              onClick={() =>
                                fileStore.handleDownloadFile(
                                  file.file_id,
                                  file.file_name
                                )
                              }
                              style={{
                                color: blue,
                                cursor: 'pointer',
                                textDecoration: 'underline',
                              }}>
                              {file.file_name}
                            </span>
                            <Tooltip title={'Xoá tập tin'}>
                              <DeleteOutlined
                                onClick={() =>
                                  handleRemoveFileFromDocumentList(file.file_id)
                                }
                              />
                            </Tooltip>
                          </UploadFileListItem>
                        ))}
                      </UploadFileListWrapper>
                    )}
                    {fileList.length !== 0 && (
                      <UploadFileListWrapper>
                        {fileList.map(file => (
                          <UploadFileListItem key={file.uid}>
                            <FileTextOutlined />
                            <span>{file.name}</span>
                            <Tooltip title={'Xoá tập tin'}>
                              <DeleteOutlined
                                onClick={() =>
                                  handleRemoveFileFromUploadList(file.uid)
                                }
                              />
                            </Tooltip>
                          </UploadFileListItem>
                        ))}
                      </UploadFileListWrapper>
                    )}
                  </Tabs.TabPane>
                </Tabs>
              </Col>
            </Row>
          </div>

          <div className="custom-create-page-footer-sticky">
            <Space>
              <Button
                danger
                className="custom-ant-button w-160"
                onClick={() => {
                  selectPeopleStore.clearSelectedHandlerAndFollower()
                  history.push('/works')
                }}>
                Hủy
              </Button>
              <Button
                className="custom-ant-button w-160"
                type={'primary'}
                htmlType={'submit'}>
                Tạo mới
              </Button>
            </Space>
          </div>
        </Form>
        <SelectPeoplePopup
          id={'create-work-select-people-popup'}
          handleCancelSelectUser={handleCancelSelectUserDepartment}
          handleSubmitSelectUser={() =>
            setIsVisibleSelectUserDepartmentPopup(false)
          }
          isVisibleSelectPeoplePopup={isVisibleSelectUserDepartmentPopup}
          ignoreSelectList={disableList}
          ignorePopupType={ASSIGNEE_TYPE.HANDLER}
        />
        <SelectGroupPopup
          id={'create-work-select-group-popup'}
          isVisibleSelectGroupPopup={isVisibleSelectGroupPopup}
          handleCancelSelectGroup={handleCancelSelectGroup}
          handleSubmitSelectGroup={() => setIsVisibleSelectGroupPopup(false)}
        />
      </DashboardLayout>
    </>
  )
}

export default inject(
  'selectPeopleStore',
  'fileStore',
  'workStore',
  'loadingAnimationStore',
  'infoOptionStore',
  'aclStore'
)(observer(CreateWorkPageV2))
